import * as Yup from "yup";

const signupFormSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email")
    .required("Email is required"),
  password: Yup.string().min(8).required("Password is required"),
  repeatPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Repeat password is required"),
  phoneNationalNumber: Yup.string().required("Phone number is required"),
  location: Yup.string().required("Location is required"),
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  acceptTermsConditions: Yup.string().required(
    "You must accept terms and conditions"
  ),
  ageDeclaration: Yup.boolean().required("You must be over 18 to collect for PlastX"),
  profilePhotoFile: Yup.mixed().required("A profile picture is required")
});

export default signupFormSchema;
